import { observer } from 'mobx-react-lite';

import {ReactComponent as MiniPuzzleIcon} from '../assets/icons/miniPuzzleIcon.svg';
import {ReactComponent as UsdnIcon} from '../assets/tokens/xtn.svg';
import {ReactComponent as EggIcon} from '../assets/tokens/EGG.svg';
import {ReactComponent as UsdtIcon} from '../assets/tokens/USDT.svg';
import {ReactComponent as UsdcIcon} from '../assets/tokens/usdc.svg';
import {ReactComponent as WavesIcon} from '../assets/tokens/waves-logo.svg';
import {ReactComponent as PeteIcon} from '../assets/tokens/pete.svg';
import {default as Select, IOption} from './Select';

interface ITokenChooserOptions {
    selected: string;
    selectFn: Function;
    className: string;
}

export default observer(function(props: ITokenChooserOptions) {
    const tokenInfo: any = {
        HEB8Qaw9xrWpWs8tHsiATYGBWDBtP2S7kcPALrMu43AS: {
            assetId: 'HEB8Qaw9xrWpWs8tHsiATYGBWDBtP2S7kcPALrMu43AS',
            title: 'Puzzle',
            decimals: 100000000,
            icon: <MiniPuzzleIcon style={{width: '21px', height: '21px'}} title="Puzzle"/>
        },
        DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p: {
            assetId: 'DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p',
            title: 'USDN',
            decimals: 1000000,
            icon: <UsdnIcon style={{width: '21px', height: '21px'}} title="XTN"/>
        },
        WAVES: {
            assetId: null,
            title: 'Waves',
            decimals: 100000000,
            icon: <WavesIcon style={{width: '21px', height: '21px'}} title="Waves"/>
        },
        C1iWsKGqLwjHUndiQ7iXpdmPum9PeCDFfyXBdJJosDRS: {
            assetId: 'C1iWsKGqLwjHUndiQ7iXpdmPum9PeCDFfyXBdJJosDRS',
            title: 'EGG',
            decimals: 100000000,
            icon: <EggIcon style={{width: '21px', height: '21px'}} title="EGG"/>
        },
        '9wc3LXNA4TEBsXyKtoLE9mrbDD7WMHXvXrCjZvabLAsi': {
            assetId: '9wc3LXNA4TEBsXyKtoLE9mrbDD7WMHXvXrCjZvabLAsi',
            title: 'USDT',
            decimals: 1000000,
            icon: <UsdtIcon style={{width: '21px', height: '21px'}} title="USDT"/>
        },
        HGgabTqUS8WtVFUJzfmrTDMgEccJuZLBPhFgQFxvnsoW: {
            assetId: 'HGgabTqUS8WtVFUJzfmrTDMgEccJuZLBPhFgQFxvnsoW',
            title: 'USDC',
            decimals: 1000000,
            icon: <UsdcIcon style={{width: '21px', height: '21px'}} title="USDC"/>
        },
        GAzAEjApmjMYZKPzri2g2VUXNvTiQGF7KDYZFFsP3AEq: {
            assetId: 'GAzAEjApmjMYZKPzri2g2VUXNvTiQGF7KDYZFFsP3AEq',
            title: 'PETE',
            decimals: 100000000,
            icon: <PeteIcon style={{width: '21px', height: '21px'}} title="PETE"/>
        }
    };

    const tokensList: IOption[] = Object.keys(tokenInfo).map((assetId) => {
        return {
            title: tokenInfo[assetId].icon,
            key: assetId
        }
    });
    
    const selectedToken = tokensList.find((item) => item.key === props.selected) || tokensList[0];

    return (
        <Select
            className={props.className}
            options={tokensList}
            selected={selectedToken}
            minWidth="80px"
            onSelect={({ key }: { key: string|null }) => {
                props.selectFn(key);
            }} />
    );
});